'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {

    var columns = [{
        id: 'edit',
        width: 62,
        Cell: function Cell(col) {
            return _react2.default.createElement(
                _IconButton2.default,
                { iconClassName: 'material-icons', onClick: function onClick() {
                        return props.onClickEditOrganizingCommittee(col.original.id);
                    } },
                'edit'
            );
        }
    }, {
        Header: 'Id',
        accessor: 'id',
        width: 240
    }, {
        Header: 'Nome',
        accessor: 'name'
    }];

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactTable2.default, {
            data: props.organizingCommittees,
            columns: columns,
            loading: props.loading,
            previousText: 'Anterior',
            nextText: 'Pr\xF3xima',
            loadingText: 'Carregando...',
            noDataText: 'N\xE3o foram encontrados bancas para este filtro',
            pageText: 'P\xE1gina',
            ofText: 'de',
            rowsText: 'linhas',
            showPaginationBottom: true,
            width: 100,
            defaultPageSize: 10,
            filterable: true
        })
    );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/organizingCommittees/oganizingCommitteesList.js
// module id = 3284
// module chunks = 0